let _initProto, _initClass, _init_value, _init_extra_value, _init_defaultValue, _init_extra_defaultValue, _init_minValue, _init_extra_minValue, _init_maxValue, _init_extra_maxValue, _init_step, _init_extra_step, _init_disabled, _init_extra_disabled, _init_readOnly, _init_extra_readOnly, _init_label, _init_extra_label, _init_name, _init_extra_name, _init_locale, _init_extra_locale, _init_formatOptions, _init_extra_formatOptions, _init_commitBehavior, _init_extra_commitBehavior, _init_incrementAriaLabel, _init_extra_incrementAriaLabel, _init_decrementAriaLabel, _init_extra_decrementAriaLabel, _init_wheelDisabled, _init_extra_wheelDisabled, _init_changeEvent, _init_extra_changeEvent, _init_decreaseDisabled, _init_extra_decreaseDisabled, _init_increaseDisabled, _init_extra_increaseDisabled;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, customElement, event, onEvent, onUpdated, prop, state } from "@ecopages/radiant";
import { formatNumber, parseFormatOptions, parseNumber, resolveLocale, snapToStep } from "@/lib/intl-number";
import { syncFieldLabel } from "../shared/field-label";
let _RuiNumberField;
class RuiNumberField extends RadiantElement {
  static {
    ({
      e: [_init_value, _init_extra_value, _init_defaultValue, _init_extra_defaultValue, _init_minValue, _init_extra_minValue, _init_maxValue, _init_extra_maxValue, _init_step, _init_extra_step, _init_disabled, _init_extra_disabled, _init_readOnly, _init_extra_readOnly, _init_label, _init_extra_label, _init_name, _init_extra_name, _init_locale, _init_extra_locale, _init_formatOptions, _init_extra_formatOptions, _init_commitBehavior, _init_extra_commitBehavior, _init_incrementAriaLabel, _init_extra_incrementAriaLabel, _init_decrementAriaLabel, _init_extra_decrementAriaLabel, _init_wheelDisabled, _init_extra_wheelDisabled, _init_changeEvent, _init_extra_changeEvent, _init_decreaseDisabled, _init_extra_decreaseDisabled, _init_increaseDisabled, _init_extra_increaseDisabled, _initProto],
      c: [_RuiNumberField, _initClass]
    } = _applyDecs(this, [customElement("rui-number-field")], [[prop({
      type: Number,
      reflect: true
    }), 0, "value"], [prop({
      type: Number,
      attribute: "default-value"
    }), 0, "defaultValue"], [prop({
      type: Number,
      attribute: "min-value",
      defaultValue: Number.NEGATIVE_INFINITY
    }), 0, "minValue"], [prop({
      type: Number,
      attribute: "max-value",
      defaultValue: Number.POSITIVE_INFINITY
    }), 0, "maxValue"], [prop({
      type: Number,
      defaultValue: 1
    }), 0, "step"], [prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "disabled"], [prop({
      type: Boolean,
      attribute: "read-only",
      reflect: true,
      defaultValue: false
    }), 0, "readOnly"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "label"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "name"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "locale"], [prop({
      type: String,
      attribute: "format-options",
      defaultValue: ""
    }), 0, "formatOptions"], [prop({
      type: String,
      attribute: "commit-behavior",
      defaultValue: "snap"
    }), 0, "commitBehavior"], [prop({
      type: String,
      attribute: "increment-aria-label",
      defaultValue: ""
    }), 0, "incrementAriaLabel"], [prop({
      type: String,
      attribute: "decrement-aria-label",
      defaultValue: ""
    }), 0, "decrementAriaLabel"], [prop({
      type: Boolean,
      attribute: "wheel-disabled",
      defaultValue: false
    }), 0, "wheelDisabled"], [event({
      name: "rui-change",
      bubbles: true,
      composed: true
    }), 0, "changeEvent"], [state, 0, "decreaseDisabled"], [state, 0, "increaseDisabled"], [onUpdated(["value", "defaultValue", "minValue", "maxValue", "step", "label", "disabled", "readOnly", "locale", "formatOptions", "commitBehavior"]), 2, "onPropsUpdated"], [onEvent({
      selector: '[data-number-field-action="decrement"]',
      type: "click"
    }), 2, "decrement"], [onEvent({
      selector: '[data-number-field-action="increment"]',
      type: "click"
    }), 2, "increment"], [onEvent({
      selector: "[data-number-field-input]",
      type: "focus"
    }), 2, "onInputFocus"], [onEvent({
      selector: "[data-number-field-input]",
      type: "blur"
    }), 2, "onInputBlur"], [onEvent({
      selector: "[data-number-field-input]",
      type: "input"
    }), 2, "onInput"], [onEvent({
      selector: "[data-number-field-input]",
      type: "keydown"
    }), 2, "onKeydown"], [onEvent({
      selector: "[data-number-field-input]",
      type: "wheel"
    }), 2, "onWheel"]], 0, void 0, RadiantElement));
  }
  value = (_initProto(this), _init_value(this));
  defaultValue = (_init_extra_value(this), _init_defaultValue(this));
  minValue = (_init_extra_defaultValue(this), _init_minValue(this));
  maxValue = (_init_extra_minValue(this), _init_maxValue(this));
  step = (_init_extra_maxValue(this), _init_step(this));
  disabled = (_init_extra_step(this), _init_disabled(this));
  readOnly = (_init_extra_disabled(this), _init_readOnly(this));
  label = (_init_extra_readOnly(this), _init_label(this));
  name = (_init_extra_label(this), _init_name(this));
  locale = (_init_extra_name(this), _init_locale(this));
  formatOptions = (_init_extra_locale(this), _init_formatOptions(this));
  commitBehavior = (_init_extra_formatOptions(this), _init_commitBehavior(this));
  incrementAriaLabel = (_init_extra_commitBehavior(this), _init_incrementAriaLabel(this));
  decrementAriaLabel = (_init_extra_incrementAriaLabel(this), _init_decrementAriaLabel(this));
  wheelDisabled = (_init_extra_decrementAriaLabel(this), _init_wheelDisabled(this));
  changeEvent = (_init_extra_wheelDisabled(this), _init_changeEvent(this));
  decreaseDisabled = (_init_extra_changeEvent(this), _init_decreaseDisabled(this, false));
  increaseDisabled = (_init_extra_decreaseDisabled(this), _init_increaseDisabled(this, false));
  editing = (_init_extra_increaseDisabled(this), false);
  draftValue = "";
  initialized = false;
  uid = Math.random().toString(36).slice(2, 9);
  get resolvedLocale() {
    return resolveLocale(this.locale);
  }
  get resolvedFormatOptions() {
    return parseFormatOptions(this.formatOptions);
  }
  get inputId() {
    return `rui-number-field-input-${this.uid}`;
  }
  getNumericValue() {
    if (typeof this.value === "number" && Number.isFinite(this.value)) {
      return this.value;
    }
    if (typeof this.defaultValue === "number" && Number.isFinite(this.defaultValue)) {
      return this.defaultValue;
    }
    return 0;
  }
  getInput() {
    return this.querySelector("[data-number-field-input]");
  }
  getHiddenInput() {
    return this.querySelector("[data-number-field-value]");
  }
  syncLabel() {
    const input = this.getInput();
    syncFieldLabel(this, input, {
      controlId: this.inputId,
      label: this.label,
      labelId: `rui-number-field-label-${this.uid}`
    });
  }
  syncInput() {
    const input = this.getInput();
    const hidden = this.getHiddenInput();
    if (!input) {
      return;
    }
    if (!input.id) {
      input.id = this.inputId;
    }
    const numericValue = this.getNumericValue();
    input.setAttribute("role", "spinbutton");
    input.setAttribute("inputmode", "decimal");
    input.toggleAttribute("data-disabled", this.disabled);
    input.toggleAttribute("data-readonly", this.readOnly);
    if (!Number.isFinite(this.minValue)) {
      input.removeAttribute("aria-valuemin");
    } else {
      input.setAttribute("aria-valuemin", String(this.minValue));
    }
    if (!Number.isFinite(this.maxValue)) {
      input.removeAttribute("aria-valuemax");
    } else {
      input.setAttribute("aria-valuemax", String(this.maxValue));
    }
    input.setAttribute("aria-valuenow", String(numericValue));
    if (!this.editing) {
      input.value = formatNumber(numericValue, this.resolvedLocale, this.resolvedFormatOptions);
    }
    if (hidden) {
      hidden.value = String(numericValue);
      if (this.name) {
        hidden.name = this.name;
      }
      hidden.disabled = this.disabled;
    }
  }
  updateStepperState() {
    const value = this.getNumericValue();
    this.decreaseDisabled = this.disabled || this.readOnly || value <= this.minValue;
    this.increaseDisabled = this.disabled || this.readOnly || value >= this.maxValue;
    queueMicrotask(() => this.syncSlottedSteppers());
  }
  syncSlottedSteppers() {
    const incrementLabel = this.incrementAriaLabel || "Increment";
    const decrementLabel = this.decrementAriaLabel || "Decrement";
    for (const button of this.querySelectorAll('[data-number-field-action="decrement"]')) {
      button.disabled = this.decreaseDisabled;
      button.setAttribute("aria-label", decrementLabel);
    }
    for (const button of this.querySelectorAll('[data-number-field-action="increment"]')) {
      button.disabled = this.increaseDisabled;
      button.setAttribute("aria-label", incrementLabel);
    }
  }
  commitValue(next, force = false) {
    let resolved = next;
    if (this.commitBehavior === "snap" || force) {
      resolved = snapToStep(next, this.minValue, this.maxValue, this.step);
    }
    if (resolved === this.getNumericValue()) {
      this.editing = false;
      this.syncInput();
      this.updateStepperState();
      return;
    }
    this.value = resolved;
    this.changeEvent.emit({
      value: resolved
    });
    this.editing = false;
    this.syncInput();
    this.updateStepperState();
  }
  commitDraft() {
    const parsed = parseNumber(this.draftValue, this.resolvedLocale, this.resolvedFormatOptions);
    if (parsed == null) {
      this.editing = false;
      this.syncInput();
      return;
    }
    if (this.commitBehavior === "validate") {
      if (parsed < this.minValue || parsed > this.maxValue) {
        this.editing = false;
        this.syncInput();
        return;
      }
    }
    this.commitValue(parsed);
  }
  initialize() {
    if (this.initialized) {
      return;
    }
    this.initialized = true;
    if (this.value == null && this.defaultValue != null) {
      this.value = this.defaultValue;
    }
    this.syncLabel();
    this.syncInput();
    this.updateStepperState();
  }
  onConnected() {
    this.initialize();
  }
  onPropsUpdated() {
    this.syncLabel();
    this.syncInput();
    this.updateStepperState();
  }
  decrement(event2) {
    event2.preventDefault();
    if (this.decreaseDisabled) {
      return;
    }
    this.commitValue(this.getNumericValue() - this.step, true);
  }
  increment(event2) {
    event2.preventDefault();
    if (this.increaseDisabled) {
      return;
    }
    this.commitValue(this.getNumericValue() + this.step, true);
  }
  onInputFocus(event2) {
    if (this.disabled || this.readOnly) {
      return;
    }
    const input = event2.target;
    this.editing = true;
    this.draftValue = String(this.getNumericValue());
    input.value = this.draftValue;
    input.select();
  }
  onInputBlur() {
    if (!this.editing) {
      return;
    }
    this.commitDraft();
  }
  onInput(event2) {
    if (this.disabled || this.readOnly) {
      return;
    }
    this.editing = true;
    this.draftValue = event2.target.value;
  }
  onKeydown(event2) {
    if (this.disabled || this.readOnly) {
      return;
    }
    if (event2.key === "ArrowUp") {
      event2.preventDefault();
      this.increment(event2);
      return;
    }
    if (event2.key === "ArrowDown") {
      event2.preventDefault();
      this.decrement(event2);
      return;
    }
    if (event2.key === "Home" && Number.isFinite(this.minValue)) {
      event2.preventDefault();
      this.commitValue(this.minValue, true);
      return;
    }
    if (event2.key === "End" && Number.isFinite(this.maxValue)) {
      event2.preventDefault();
      this.commitValue(this.maxValue, true);
      return;
    }
    if (event2.key === "Enter") {
      event2.preventDefault();
      this.commitDraft();
      this.getInput()?.blur();
    }
  }
  onWheel(event2) {
    if (this.wheelDisabled || this.disabled || this.readOnly) {
      return;
    }
    const input = event2.target;
    if (document.activeElement !== input) {
      return;
    }
    event2.preventDefault();
    if (event2.deltaY < 0) {
      this.increment(event2);
    } else if (event2.deltaY > 0) {
      this.decrement(event2);
    }
  }
  static {
    _initClass();
  }
}
export { _RuiNumberField as RuiNumberField };